
export default {
    props: {
        logoType: {
            type: String,
            default: null
        }
    }
};
